import { ReactNode } from "react";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type ViewHeaderNavigationProps = {
  children: ReactNode;
};

const ViewHeaderNavigation = ({ children }: ViewHeaderNavigationProps) => {
  return (
    <Box
      align="center"
      justify="start"
      margin="medium 0 0"
      gap="medium"
      fullWidth
      className={styles.wrapper}
    >
      {children}
    </Box>
  );
};

export default ViewHeaderNavigation;
